/**
 * Application Configuration
 * Centralized configuration values that can be overridden via environment variables
 */

// Contact & Support
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL || 'support@reppr.io'
export const NOREPLY_EMAIL = import.meta.env.VITE_NOREPLY_EMAIL || 'noreply@reppr.io'

// No Stripe URLs live here any more (Aug 2026). The self-serve $49/$99 checkout
// links went when pricing became sales-led, and the billing portal URL went with
// them: it had no caller either, because Settings opens the portal through
// /api/billing?action=portal, which mints a session for the signed-in customer
// server-side. A hardcoded portal link cannot do that, and the one that sat here
// as a fallback would have shipped in the bundle regardless of environment.

// Application URLs
export const APP_URL = import.meta.env.VITE_APP_URL || (import.meta.env.PROD ? 'https://www.reppr.io' : 'http://localhost:3000')
export const POCKETBASE_URL = import.meta.env.VITE_POCKETBASE_URL || 'http://localhost:8090'
export const SCRAPER_API_URL = import.meta.env.VITE_SCRAPER_API_URL || 'http://localhost:3002'
export const MANUAL_INCENTIVES_ONLY = String(import.meta.env.VITE_MANUAL_INCENTIVES_ONLY ?? 'true').toLowerCase() !== 'false'

// Demo Booking
export const DEMO_BOOKING_URL = import.meta.env.VITE_DEMO_BOOKING_URL || 'https://calendar.app.google/zHkFNMbSvy6hn4RQ7'

// Company Info
export const COMPANY_NAME = 'Elite Sports Solutions LLC'
export const APP_NAME = 'Reppr'

// Helper to generate mailto links
export function getSupportMailto(subject?: string): string {
  const base = `mailto:${SUPPORT_EMAIL}`
  return subject ? `${base}?subject=${encodeURIComponent(subject)}` : base
}
